import React from 'react'
import styles from './styles.module.css'

const Index = ({text = 'НЕТ ДАННЫХ'}) => {
  return (
    <div className={styles.wrapper}>{text}</div>
  )
}

export default Index
